import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { DataComparisonApiService } from 'src/services/dataComparisonApi'

// The saved definitions. A row never changes after it is saved — the report is
// computed when a row is opened — so the list has nothing to poll for.
export const useGetDataComparisonsQuery = (campaignId?: string) =>
  useQuery({
    enabled: !!campaignId,
    queryFn: () => DataComparisonApiService.getList(campaignId as string),
    queryKey: [QueryKey.GET_DATA_COMPARISONS, campaignId],
  })
